var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('header',[_vm._t("header",function(){return [_c('Header')]})],2),_vm._v(" "),_c('main',[_vm._t("main",function(){return [_c('router-view')]})],2),_vm._v(" "),_c('footer',[_vm._t("footer",function(){return [_c('Footer')]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73c5e634","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/index.vue
// module id = null
// module chunks = 